













































































































import { Vue, Component } from 'vue-property-decorator';
import { ObjectFactory } from '../config/objectFactory';
import Menu from '../components/Menu.vue';
import { Condition } from '@/types/queryRequest';
import { AdvanceFilterRequest } from '@/types/request';
import { ModelSelect } from 'vue-search-select';
import { HealthcareProvider, OrgLocation, Patient } from '@/types/entity';
import { MedTransGoConstants } from '@/util/constants';
import DataTable from '@/components/DataTable.vue';
import { DateUtils } from '@/util/dateUtils';
import { MathUtils } from '@/util/mathUtils';
import { ResourceUtils } from '@/util/resourceUtils';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import saveAs from 'file-saver';

// tslint:disable-next-line: no-var-requires
const ReportsTable = require('../datatable/ReportsTable.json');
// tslint:disable-next-line: no-var-requires
const PatientInvoiceTable = require('../datatable/PatientInvoiceTable');

@Component({
    data() {
        return {
            header: 'Reports',
            menuOptions: [{
                url: 'reports?reportType=service',
                activeConditions: {
                    reportType: 'service',
                },
                label: 'Service Report',
            },
            {
                url: 'reports?reportType=invoice',
                activeConditions: {
                    reportType: 'invoice',
                },
                label: 'Patient Invoice',
            },
            ],
            serviceOptions: [
                {
                    value: '',
                    text: 'All',
                },
                {
                    value: 'transportRequest',
                    text: 'Transportation',
                },
                {
                    value: 'interpreterRequest',
                    text: 'Interpretation',
                },
                {
                    value: 'telemedicineRequest',
                    text: 'Telemedicine',
                },
                {
                    value: 'deliveryRequest',
                    text: 'Delivery',
                },
            ],
            statusOptions: [
                {
                    value: '',
                    text: 'All',
                },
                {
                    value: 'Pending',
                    text: 'Pending',
                },
                {
                    value: 'Confirmed',
                    text: 'Confirmed',
                },
                {
                    value: 'Completed',
                    text: 'Completed',
                },
                {
                    value: 'Canceled',
                    text: 'Canceled',
                },
            ],
            billingLocationOptions: [],
            providersOptions: [],
            patientOptions: [],
        };
    },
    components: {
        Menu,
        ModelSelect,
        DataTable,
    },
})
export default class Reports extends Vue {

    private advanceFilterRequest: AdvanceFilterRequest = {};
    private locations: OrgLocation[] = [];
    private healthcareProviders: HealthcareProvider[] = [];
    private service: any | undefined = '';
    private invoice: any | undefined = '';
    private billingLocationId: string | undefined = '';
    private facilityName: string | undefined = '';
    private requestStatus: string | undefined = '';
    private startDate: any | undefined = '';
    private endDate: any | undefined = '';
    private reportsDataSource = ReportsTable;
    private invoiceDataSource = PatientInvoiceTable;
    private patients: Patient[] = [];
    private patientName: string | undefined = '';
    private type: any = 'I';
    private card = '';
    public mounted() {
        this.getOrganizationLocations();
        this.getHealthcareProviders();
        this.getPatients();
    }

    private async genrateReport(searchString?: string, start?: number, reportType?: string) {
        const requestType = this.service;
        const conditions: Condition[] = [];
        if (this.billingLocationId && this.billingLocationId !== '') {
            const condition: Condition = {
                op: 'eq',
                fieldName: 'locationId',
                value: this.billingLocationId,
            };
            conditions.push(condition);
        }
        if (this.facilityName && this.facilityName !== '') {
            const condition: Condition = {
                op: 'eq',
                fieldName: 'appointment.facility.name',
                value: this.facilityName,
            };
            conditions.push(condition);
        }
        if (this.startDate && this.startDate !== '' && this.endDate && this.endDate !== '') {
            this.advanceFilterRequest = {
                appointmentDate: {
                    startDate: this.startDate,
                    endDate: this.endDate,
                },
            };
        }
        if (this.requestStatus && this.requestStatus !== '') {
            const condition: Condition = {
                op: 'eq',
                fieldName: 'status',
                value: this.requestStatus,
            };
            conditions.push(condition);
        }
        const response = await ObjectFactory.getRequestService().getRequests({
            baseURL: this.$store.state.serverUrl,
            advanceSearchRequest: this.advanceFilterRequest,
            service: requestType,
            start,
            conditions,
            responseType: reportType as any,
        });
        if (response.success && response.data) {
            response.data.forEach((element) => {
                const serviceRequest = element;
                if (serviceRequest.transportRequest && serviceRequest.interpreterRequest) {
                    serviceRequest.serviceType = 'Transportation & Interpretation';
                } else if (serviceRequest.interpreterRequest && serviceRequest.telemedicineRequest) {
                    serviceRequest.serviceType = `Telemedicine & Interpretation (${serviceRequest.interpreterRequest.serviceType})`;
                } else if (serviceRequest.telemedicineRequest) {
                    serviceRequest.serviceType = 'Telemedicine';
                } else if (serviceRequest.transportRequest) {
                    serviceRequest.serviceType = 'Transportation';
                } else if (serviceRequest.interpreterRequest) {
                    serviceRequest.serviceType = `Interpretation (${serviceRequest.interpreterRequest.serviceType})`;
                } else if (serviceRequest.deliveryRequest) {
                    serviceRequest.serviceType = 'Medication Delivery';
                } else if (serviceRequest.cmrRequest) {
                    serviceRequest.serviceType = 'Comprehensive Medication Review';
                } else if (serviceRequest.transportRequest && serviceRequest.homeAssistanceRequest) {
                    serviceRequest.serviceType = 'Transportation + Home Assistance';
                }
                element.appointment.date = DateUtils.formatDate(serviceRequest.appointment.timestamp,
                    'MM/DD/YYYY') as any;
                element.appointment.timestamp = DateUtils.formatDate(serviceRequest.appointment.timestamp,
                    'hh: mm a z') as any;
                if (element.payment) {
                    let depositAmount = 0;
                    const estimatedFare = element.payment.estimatedFare;
                    estimatedFare.particulars.forEach((particular) => {
                        if (particular.description === 'Deposit (Refundable)') {
                            depositAmount += particular.amount;
                        }
                    });
                    element.payment.estimatedFare.totalAmount = MathUtils.formatCurrency
                        (element.payment.estimatedFare.totalAmount - depositAmount) as any;
                    if (element.payment.paymentResponse) {
                        element.payment.paymentResponse.amount = MathUtils.formatCurrency
                            (element.payment.paymentResponse.amount);
                    }
                }
            });
            this.reportsDataSource.data = response.data;
            this.reportsDataSource.totalCount = response.totalCount;
        }
    }

    private async getOrganizationLocations() {
        this.$data.billingLocationOptions = [];
        const response = await ObjectFactory.getOrganizationService().getLocations(this.$store.state.serverUrl);
        if (response.success && response.data) {
            this.locations = response.data;
            response.data.forEach((location) => {
                const option = {
                    value: location.id,
                    text: location.locationName,
                };
                this.$data.billingLocationOptions.push(option);
            });
            const allOption = {
                value: '',
                text: 'All',
            };
            this.$data.billingLocationOptions.push(allOption);
        }
    }
    private async getHealthcareProviders() {
        const response = await ObjectFactory.getProviderService()
            .getHealthcareProviders(this.$store.state.serverUrl, '', 0, MedTransGoConstants.DB_QUERY_MAX_RESULT);
        this.healthcareProviders = response.data as any;
        this.$data.providersOptions = [];
        this.healthcareProviders.forEach((healthcareProvider) => {
            if (healthcareProvider.status === 'ACTIVE') {
                const providersOption = {
                    value: healthcareProvider.fullname,
                    text: healthcareProvider.fullname,
                };
                this.$data.providersOptions.push(providersOption);
            }
        });
        const allOption = {
            value: '',
            text: 'All',
        };
        this.$data.providersOptions.push(allOption);
    }

    private async searchPatientInvoice(searchString?: string, start?: number) {
        this.type = this.$route.query.type ? this.$route.query.type : 'I';
        const conditions: Condition[] = [];
        if (this.patientName && this.patientName !== '') {
            const condition: Condition = {
                op: 'eq',
                fieldName: 'customerName',
                value: this.patientName,
            };
            conditions.push(condition);
        }
        if (this.startDate && this.startDate !== '' && this.endDate && this.endDate !== '') {
            this.advanceFilterRequest = {
                appointmentDate: {
                    startDate: this.startDate,
                    endDate: this.endDate,
                },
            };
        }
        const response = await ObjectFactory.getInvoiceService().getInvoiceList(this.$store.state.serverUrl, {
            conditions,
            advanceFilterRequest: this.advanceFilterRequest,
            start,
            limit: MedTransGoConstants.PAGINATION_LIMIT,
        }, this.type);
        if (response.success && response.data) {
            response.data.forEach((element: any) => {
                element.totalAmount = 0;
                element.particulars.forEach((iElement: any) => {
                    element.totalAmount += iElement.amount;
                });
                element.totalAmount = MathUtils.formatCurrency(element.totalAmount);
                element.createdOn = DateUtils.formatDate(element.createdOn);
            });
            this.invoiceDataSource.data = response.data;
            this.invoiceDataSource.totalCount = response.totalCount;
        }
    }

    private async downloadInvoice(invoice: any) {
        const pdfBuffer = await ObjectFactory.getInvoiceService().
            getInvoiceReceipt(this.$store.state.serverUrl, invoice.id) as any;
        const file = new Blob([pdfBuffer], { type: 'application/pdf' });
        ResourceUtils.downloadFileIntoDevice(file, `${invoice.invoiceId}.pdf`);
    }

    private async getPatients() {
        const response = await ObjectFactory.getPatientService()
            .getPatientList(this.$store.state.serverUrl, '', 0, MedTransGoConstants.DB_QUERY_MAX_RESULT);
        this.patients = response.data as any;
        this.$data.patientOptions = [];
        this.patients.forEach((patient) => {
            const patientOption = {
                value: patient.fullName,
                text: patient.fullName,
            };
            this.$data.patientOptions.push(patientOption);
        });
        const allOption = {
            value: '',
            text: 'All',
        };
        this.$data.patientOptions.push(allOption);
    }

    private async downloadZipFile() {
        const conditions: Condition[] = [];
        if (this.patientName && this.patientName !== '') {
            const condition: Condition = {
                op: 'eq',
                fieldName: 'customerName',
                value: this.patientName,
            };
            conditions.push(condition);
        }
        const response = await ObjectFactory.getInvoiceService().getInvoiceList(this.$store.state.serverUrl, {
            conditions,
            advanceFilterRequest: this.advanceFilterRequest,
            limit: MedTransGoConstants.PAGINATION_LIMIT,
        }, this.type);
        if (response.success && response.data && response.data.length) {
            const invoiceArray: any[] = [];
            for (const element of response.data) {
                const invoiceId = element.invoiceId;
                const resourceId = element.originalPdfResourceId ? element.originalPdfResourceId : '';
                const invoice = await ObjectFactory.getInvoiceService().getResource(this.$store.state.serverUrl,
                    resourceId) as any;
                invoiceArray.push({ url: invoice, invoiceId });
            }
            const zip = new JSZip();
            let count = 0;
            const zipFileName = 'Invoices.zip';
            invoiceArray.forEach((element) => {
                JSZipUtils.getBinaryContent(element.url, (err: any, data: any) => {
                    if (err) {
                        throw err;
                    }
                    zip.file(`${element.invoiceId}.pdf`, data, {
                        binary: true,
                        createFolders: false,
                    });
                    count++;
                    if (count === invoiceArray.length) {
                        zip.generateAsync({
                            type: 'blob',
                        })
                            .then((blob) => {
                                saveAs(blob, zipFileName);
                            });
                    }
                });
            });
        }
    }
}
